import { Button, FlexBox, Text } from '@dixa/lib-shared-habla';
import { useHasAccess } from 'lib-shared-access-control';
import type { ConversationAutomationChatbotSingleInteractionLogEntry } from 'lib-shared-types-api';
import { useCallback } from 'react';

import { useAppNavigate } from 'utils/url/useAppNavigate';

import { exitReasonLabel } from '../exitReasonLabel';

type RoutedThroughChatbotSingleInteractionProps = {
  readonly node: ConversationAutomationChatbotSingleInteractionLogEntry;
};

export function RoutedThroughChatbotSingleInteraction({
  node,
}: RoutedThroughChatbotSingleInteractionProps): JSX.Element {
  const navigate = useAppNavigate();
  const hasAiAgentReadAccess = useHasAccess([
    'settings.integration.channel.edit',
    'settings.chatbot',
  ]);

  const handleGoToAiAgent = useCallback(() => {
    if (!node.chatbot_id) return;
    navigate({
      path: '/settings/ai-agents/mim/:id',
      params: {
        path: {
          id: node.chatbot_id,
        },
      },
    });
  }, [navigate, node.chatbot_id]);

  return (
    <FlexBox alignItems="center" gap="200">
      <Text.Paragraph>
        AI agent (one reply)
        {node.chatbot_name && (
          <>
            : <strong>{node.chatbot_name}</strong>
          </>
        )}{' '}
        {node.exit_reason && exitReasonLabel[node.exit_reason] && (
          <>
            · <strong>{exitReasonLabel[node.exit_reason]}</strong>
          </>
        )}
      </Text.Paragraph>
      {hasAiAgentReadAccess && node.chatbot_id && (
        <Button variant="secondary" onClick={handleGoToAiAgent}>
          Go to AI agent
        </Button>
      )}
    </FlexBox>
  );
}
